// Edit Site Profile Action Types

// Fetch Site Details Action Types
export const FETCH_SITE_DETAILS_REQUEST = "FETCH_SITE_DETAILS_REQUEST";
export const FETCH_SITE_DETAILS_SUCCESS = "FETCH_SITE_DETAILS_SUCCESS";
export const FETCH_SITE_DETAILS_FAILURE = "FETCH_SITE_DETAILS_FAILURE";

// Fetch Zipcode Action Types
export const FETCH_ZIPCODE_DETAILS_REQUEST = "FETCH_ZIPCODE_DETAILS_REQUEST";
export const FETCH_ZIPCODE_DETAILS_SUCCESS = "FETCH_ZIPCODE_DETAILS_SUCCESS";
export const FETCH_ZIPCODE_DETAILS_FAILURE = "FETCH_ZIPCODE_DETAILS_FAILURE";

// Save Site Details Action Types
export const SAVE_SITE_DETAILS_REQUEST = "SAVE_SITE_DETAILS_REQUEST";
export const SAVE_SITE_DETAILS_SUCCESS = "SAVE_SITE_DETAILS_SUCCESS";
export const SAVE_SITE_DETAILS_FAILURE = "SAVE_SITE_DETAILS_FAILURE";

// Save Priority SLA Action Types
export const SAVE_PRIORITY_SLA_REQUEST = "SAVE_PRIORITY_SLA_REQUEST";
export const SAVE_PRIORITY_SLA_SUCCESS = "SAVE_PRIORITY_SLA_SUCCESS";
export const SAVE_PRIORITY_SLA_FAILURE = "SAVE_PRIORITY_SLA_FAILURE";

// Save Site Tags Action Types
export const SAVE_SITE_TAGS_REQUEST = "SAVE_SITE_TAGS_REQUEST";
export const SAVE_SITE_TAGS_SUCCESS = "SAVE_SITE_TAGS_SUCCESS";
export const SAVE_SITE_TAGS_FAILURE = "SAVE_SITE_TAGS_FAILURE";

// Fetch Sister Sites Action Types
export const FETCH_SISTER_SITES_REQUEST = "FETCH_SISTER_SITES_REQUEST";
export const FETCH_SISTER_SITES_SUCCESS = "FETCH_SISTER_SITES_SUCCESS";
export const FETCH_SISTER_SITES_FAILURE = "FETCH_SISTER_SITES_FAILURE";

// Fetch Site Alias Action Types
export const FETCH_SITE_ALIAS_REQUEST = "FETCH_SITE_ALIAS_REQUEST";
export const FETCH_SITE_ALIAS_SUCCESS = "FETCH_SITE_ALIAS_SUCCESS";
export const FETCH_SITE_ALIAS_FAILURE = "FETCH_SITE_ALIAS_FAILURE";

// Fetch Site Alias History Action Types
export const FETCH_SITE_ALIAS_HISTORY_REQUEST =
  "FETCH_SITE_ALIAS_HISTORY_REQUEST";
export const FETCH_SITE_ALIAS_HISTORY_SUCCESS =
  "FETCH_SITE_ALIAS_HISTORY_SUCCESS";
export const FETCH_SITE_ALIAS_HISTORY_FAILURE =
  "FETCH_SITE_ALIAS_HISTORY_FAILURE";

// Fetch Sister Site History Action Types
export const FETCH_SISTER_SITE_HISTORY_REQUEST =
  "FETCH_SISTER_SITE_HISTORY_REQUEST";
export const FETCH_SISTER_SITE_HISTORY_SUCCESS =
  "FETCH_SISTER_SITE_HISTORY_SUCCESS";
export const FETCH_SISTER_SITE_HISTORY_FAILURE =
  "FETCH_SISTER_SITE_HISTORY_FAILURE";

// Save Site Alias Action Types
export const SAVE_SITE_ALIAS_REQUEST = "SAVE_SITE_ALIAS_REQUEST";
export const SAVE_SITE_ALIAS_SUCCESS = "SAVE_SITE_ALIAS_SUCCESS";
export const SAVE_SITE_ALIAS_FAILURE = "SAVE_SITE_ALIAS_FAILURE";

// Fetch Model Input Files Action Types
export const FETCH_MODEL_INPUT_FILES_REQUEST =
  "FETCH_MODEL_INPUT_FILES_REQUEST";
export const FETCH_MODEL_INPUT_FILES_SUCCESS =
  "FETCH_MODEL_INPUT_FILES_SUCCESS";
export const FETCH_MODEL_INPUT_FILES_FAILURE =
  "FETCH_MODEL_INPUT_FILES_FAILURE";

// Fetch Model Input Files Processed Result Action Types
export const FETCH_MODEL_PROCESSED_FILES_REQUEST =
  "FETCH_MODEL_PROCESSED_FILES_REQUEST";
export const FETCH_MODEL_PROCESSED_FILES_SUCCESS =
  "FETCH_MODEL_PROCESSED_FILES_SUCCESS";
export const FETCH_MODEL_PROCESSED_FILES_FAILURE =
  "FETCH_MODEL_PROCESSED_FILES_FAILURE";

// Fetch Site Model Filter (Overall Priority / Modality Mix)
export const FETCH_SITE_MODEL_FILTER_REQUEST =
  "FETCH_SITE_MODEL_FILTER_REQUEST";
export const FETCH_SITE_MODEL_FILTER_SUCCESS =
  "FETCH_SITE_MODEL_FILTER_SUCCESS";
export const FETCH_SITE_MODEL_FILTER_FAILURE =
  "FETCH_SITE_MODEL_FILTER_FAILURE";

// Download Site Model Input Template Action Types
export const DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_REQUEST =
  "DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_REQUEST";
export const DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_SUCCESS =
  "DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_SUCCESS";
export const DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_FAILURE =
  "DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_FAILURE";
// Upload Site Model Input File Action Types
export const SITE_MODEL_INPUT_UPLOAD_REQUEST =
  "SITE_MODEL_INPUT_UPLOAD_REQUEST";
export const SITE_MODEL_INPUT_UPLOAD_SUCCESS =
  "SITE_MODEL_INPUT_UPLOAD_SUCCESS";
export const SITE_MODEL_INPUT_UPLOAD_FAILURE =
  "SITE_MODEL_INPUT_UPLOAD_FAILURE";

// Save Site Model Input Action Types
export const SAVE_SITE_MODEL_INPUT_REQUEST = "SAVE_SITE_MODEL_INPUT_REQUEST";
export const SAVE_SITE_MODEL_INPUT_SUCCESS = "SAVE_SITE_MODEL_INPUT_SUCCESS";
export const SAVE_SITE_MODEL_INPUT_FAILURE = "SAVE_SITE_MODEL_INPUT_FAILURE";

// Fetch Priority / Subspeciality Split Action Types
export const FETCH_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST =
  "FETCH_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST";
export const FETCH_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS =
  "FETCH_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS";
export const FETCH_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE =
  "FETCH_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE";

// Save Priority / Subspeciality Split Action Types
export const SAVE_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST =
  "SAVE_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST";
export const SAVE_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS =
  "SAVE_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS";
export const SAVE_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE =
  "SAVE_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE";

// Check Priority / Subspeciality Config Availability Action Types
export const CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_REQUEST =
  "CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_REQUEST";
export const CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_SUCCESS =
  "CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_SUCCESS";
export const CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_FAILURE =
  "CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_FAILURE";

// Enable / Disable Sister Site
export const ENABLE_DISABLE_SISTER_SITE_REQUEST =
  "ENABLE_DISABLE_SISTER_SITE_REQUEST";
export const ENABLE_DISABLE_SISTER_SITE_SUCCESS =
  "ENABLE_DISABLE_SISTER_SITE_SUCCESS";
export const ENABLE_DISABLE_SISTER_SITE_FAILURE =
  "ENABLE_DISABLE_SISTER_SITE_FAILURE";

//Get Site Onboarding Details Action Types
export const FETCH_SITE_ONBOARDING_DETAILS_REQUEST =
  "FETCH_SITE_ONBOARDING_DETAILS_REQUEST";
export const FETCH_SITE_ONBOARDING_DETAILS_SUCCESS =
  "FETCH_SITE_ONBOARDING_DETAILS_SUCCESS";
export const FETCH_SITE_ONBOARDING_DETAILS_FAILURE =
  "FETCH_SITE_ONBOARDING_DETAILS_FAILURE";

// State Master (for scheduling state dropdown on site)
export const FETCH_STATE_LIST_REQUEST = "FETCH_STATE_LIST_REQUEST";
export const FETCH_STATE_LIST_SUCCESS = "FETCH_STATE_LIST_SUCCESS";
export const FETCH_STATE_LIST_FAILURE = "FETCH_STATE_LIST_FAILURE";

// Update site scheduling state
export const UPDATE_SITE_STATE_REQUEST = "UPDATE_SITE_STATE_REQUEST";
export const UPDATE_SITE_STATE_SUCCESS = "UPDATE_SITE_STATE_SUCCESS";
export const UPDATE_SITE_STATE_FAILURE = "UPDATE_SITE_STATE_FAILURE";
